import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { DeviceTokenService } from '@app/shared/services/device-token.service';

/**
 * PUBLIC device-enrollment landing page: an admin creates a device and sends
 * the one-time link `/device-enroll/<code>` — opening it ON that device
 * exchanges the code for a device token (stored locally, never shown), so the
 * public break-glass verify pages return the FULL document on this device.
 */
@Component({
  selector: 'app-device-enroll',
  templateUrl: './device-enroll.component.html',
  styleUrls: ['./device-enroll.component.sass'],
})
export class DeviceEnrollComponent implements OnInit {
  public loading = true;
  public failed = false;
  public deviceName: string | null = null;

  constructor(
    private readonly http: HttpClient,
    private readonly route: ActivatedRoute,
    private readonly deviceTokens: DeviceTokenService,
  ) {}

  public ngOnInit(): void {
    const code = this.route.snapshot.paramMap.get('code');
    if (!code) {
      this.loading = false;
      this.failed = true;
      return;
    }
    this.http
      .post<{ deviceToken: string; name: string }>(`${environment.apiUrl}/devices/enroll`, { code })
      .subscribe(
        ({ deviceToken, name }) => {
          this.deviceTokens.setToken(deviceToken);
          this.deviceName = name;
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.failed = true;
        },
      );
  }
}
